<!-- ✅ STEP 1: MOBILE DROPDOWN ONLY -->
<div class="mobile-applications-container d-block d-md-none">
    <label class="dropdown-label">My Applications</label>
    <select class="mobile-app-dropdown" [(ngModel)]="selectedApplicationId" (change)="onApplicationChange($event)">
        <option value="">-- Select Application --</option>
        <option *ngFor="let app of applicationData" [value]="app._id">
            {{ app?.wishlist[0]?.courseName }} - {{ app?.wishlist[0]?.universityName }}
        </option>
    </select>
</div>

<!-- ✅ STEP 2: MOBILE SELECTED REQUEST CARD -->
<div class="selected-mobile-request-card d-block d-md-none" *ngIf="selectedApplication">
    <div class="card-summary">
        <div class="program-title">
            {{ selectedApplication?.wishlist[0]?.courseName }}
        </div>
        <div class="university-name">
            {{ selectedApplication?.wishlist[0]?.universityName }}
        </div>
        <div class="meta-info">
            <div class="app-id">
                <i class="bi bi-file-earmark-text"></i> ID: {{ selectedApplication?.applicationId }}
            </div>
            <div class="app-date">
                <i class="bi bi-clock"></i> {{ selectedApplication?.createdAt | date:'MM/dd/yyyy h:mm a' }}
            </div>
        </div>
        <div class="status-box">
            <span class="status-label">Status:</span>
            <span class="status-value">{{ selectedApplication?.applicationStatus }}</span>
        </div>
        <div class="view-course-link text-end">
            <a href="#" class="view-course-anchor">View Course Details <i class="bi bi-box-arrow-up-right"></i></a>
        </div>
    </div>
</div>

<!-- ✅ STEP 3: MOBILE CHAT PANEL -->
<div class="mobile-chat-wrapper d-block d-md-none" *ngIf="selectedApplicationId">
    <div class="chat-header-mobile">
        Chat with Counsellor
    </div>
    <fa-chat-app [chatData]="chatData" [currentUserId]="currentUserId" [currentUserName]="currentUserName"
        (sendMessageEvent)="handleSendMessage($event)" (uploadFileEvent)="handleFileUpload($event)">
    </fa-chat-app>
</div>



<!-- 🔽 Your existing layout starts here -->
<div class="row mb-10 d-none d-md-flex ">
    <div class="col-5 card-container container-height mb-4" #scrollContainer>
        <div *ngIf="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>

        <div *ngIf="error" class="alert alert-danger" role="alert">
            {{ error }}
        </div>

        <div>
            <div class="mb-4" *ngFor="let application of applicationData">
                <div class="application-card h-100"
                    [ngClass]="{ 'selected': application._id === selectedApplicationId }"
                    (click)="selectApplication(application._id)">
                    <div class="row">
                        <div class="col-12">
                            <h1 class="heading">{{ application?.wishlist[0]?.courseName }}</h1>
                            <h2 class="university">{{ application?.wishlist[0]?.universityName }}</h2>
                        </div>
                    </div>

                    <div class="row align-items-center mb-3">
                        <div class="col-6">
                            <span class="reference-number">
                                <i class="bi bi-file-text"></i> ID: {{ application?.applicationId }}
                            </span>
                        </div>
                        <div class="col-6 text-end">
                            <span class="timestamp">
                                <i class="bi bi-clock"></i> {{ application?.createdAt | date:'MM/dd/yyyy' }}
                            </span>
                        </div>
                    </div>

                    <div class="status-box mt-auto">
                        <div class="row">
                            <div class="col-12">
                                <p class="status-label d-inline">Status:</p>
                                <p class="status-value d-inline">{{ application?.applicationStatus }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!loading && !error && (!applicationData || applicationData.length === 0)"
            class="alert alert-info text-center">
            No applications found.
        </div>
    </div>

    <!-- Chat Area (Right Column) -->
    <div class="container col-7 container-height">
        <div *ngIf="!selectedApplicationId" class="select-application-prompt">
            Please select an application to start chatting
        </div>
        <fa-chat-app *ngIf="selectedApplicationId" [chatData]="chatData" [currentUserId]="currentUserId"
            [currentUserName]="currentUserName" (sendMessageEvent)="handleSendMessage($event)"
            (uploadFileEvent)="handleFileUpload($event)">
        </fa-chat-app>
    </div>
</div>